import ClientPassengerInterface from '../../interfaces/client/Passenger'
import ReferenceInterface from '../../interfaces/client/Reference'

import isPassengerEqual from './isPassengerEqual'

/**
 *
 * @param Array The passengers where we want to check if there is a passenger we can reference them to.
 * @param Array The passengers where the reference should be made to.
 */
export default (
  passengersToRef: ClientPassengerInterface[],
  referencePassengers: ClientPassengerInterface[]
) =>
  passengersToRef.reduce(
    (
      allPassengers: ReferenceInterface,
      currentPassenger: ClientPassengerInterface
    ) => {
      const existingPassenger = referencePassengers.find(
        (refencePassenger: ClientPassengerInterface) =>
          isPassengerEqual(currentPassenger, refencePassenger)
      )

      if (!existingPassenger) return allPassengers

      return {
        ...allPassengers,
        [currentPassenger.id]: existingPassenger.id,
      }
    },
    {}
  )
